import React, { useMemo } from "react";
import { useApp } from "../contexts/AppContext";

export default function SparkleEffect() {
  const { settings } = useApp();
  const sparkles = useMemo(
    () =>
      Array.from({ length: 30 }).map((_, i) => ({
        top: Math.random() * 100,
        left: Math.random() * 100,
        size: 6 + Math.random() * 10,
        duration: 2 + Math.random() * 4,
        delay: Math.random() * -5,
        color: ["#FFD93D", "#FF6B6B", "#FFFFFF", "#005F73"][i % 4],
      })),
    []
  );
  if (!settings.sparkles_enabled) return null;
  return (
    <div className="pointer-events-none fixed inset-0 z-[55] overflow-hidden" data-testid="sparkles-effect">
      {sparkles.map((s, i) => (
        <span
          key={i}
          className="absolute"
          style={{
            top: `${s.top}%`,
            left: `${s.left}%`,
            width: s.size,
            height: s.size,
            color: s.color,
            opacity: 0.85,
            animation: `sparkle-twinkle ${s.duration}s ease-in-out ${s.delay}s infinite`,
          }}
        >
          <svg viewBox="0 0 24 24" fill="currentColor" width={s.size} height={s.size}>
            <path d="M12 0 L13.5 9 L24 12 L13.5 15 L12 24 L10.5 15 L0 12 L10.5 9 Z" />
          </svg>
        </span>
      ))}
      <style>{`@keyframes sparkle-twinkle { 0%,100% { opacity:0.2; transform:scale(0.6) rotate(0deg);} 50% { opacity:1; transform:scale(1.2) rotate(180deg);} }`}</style>
    </div>
  );
}
